module.exports = __webpack_public_path__ + "static/ceramic06-f0b09d1f2edfead858a3226f07e8d832.jpg";